var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTranslate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12862_34392)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.4141 8.33268L19.0807 17.4993H17.2849L16.2841 14.9993H12.8757L11.8766 17.4993H10.0816L13.7474 8.33268H15.4141ZM8.33073 1.66602V3.33268H13.3307V4.99935H11.6907C11.0479 6.93441 10.022 8.7202 8.67406 10.2502C9.27515 10.7865 9.92713 11.2629 10.6207 11.6727L9.99489 13.2377C9.09949 12.7298 8.26206 12.126 7.4974 11.4368C6.00872 12.7841 4.24576 13.7928 2.3299 14.3935L1.88323 12.786C3.52476 12.2626 5.03741 11.3988 6.3224 10.251C5.3713 9.1743 4.57912 7.96707 3.9699 6.66602H5.83656C6.30102 7.5234 6.85795 8.32735 7.4974 9.06352C8.53915 7.86277 9.36015 6.4871 9.9224 5.00018L1.66406 4.99935V3.33268H6.66406V1.66602H8.33073ZM14.5807 10.7368L13.5416 13.3327H15.6182L14.5807 10.7368Z",
    fill: "#101113"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12862_34392"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTranslate);
export default __webpack_public_path__ + "static/media/translate.6d0f4a4a6ff237b24b297bf47d7b5261.svg";
export { ForwardRef as ReactComponent };